import React from "react";
import {
  SFCheckboxUnchecked,
  SFCheckboxChecked,
} from "../icons";
import CustomCheckbox from "./customCheckbox";

const SFCheckbox = ({
  checked = false,
  disabled = false,
  required = false,
  label,
  labelPlacement = "end",
  onChange,
  variant = "body2",
  indeterminate = false,
  size = "medium",
  defaultChecked,
}) => {
  return (
    <CustomCheckbox
      {...(typeof defaultChecked === "undefined" && { checked })}
      checked={checked}
      disabled={disabled}
      defaultChecked={defaultChecked}
      label={label}
      required={required}
      labelPlacement={labelPlacement}
      onChange={onChange}
      variant={variant}
      indeterminate={indeterminate}
      checkedIcon={<SFCheckboxChecked size={size} color={"blue300"} />}
      icon={<SFCheckboxUnchecked size={size} color={"grey300"} />}
    />
  );
};

SFCheckbox.propTypes = {
  /* Variant of the label text. */
  variant: CustomCheckbox.propTypes.variant,
  /* Label positioning if a label is supplied */
  labelPlacement: CustomCheckbox.propTypes.labelPlacement,
  /* The label to display */
  label: CustomCheckbox.propTypes.label,
  /* If true, the component is checked. */
  checked: CustomCheckbox.propTypes.checked,
  /* If true, the component is disabled. */
  disabled: CustomCheckbox.propTypes.disabled,
  /* Callback fired when the state is changed.*/
  onChange: CustomCheckbox.propTypes.onChange,
  /* If true it will render the indeterminate icon.Has more weight than checked*/
  indeterminate: CustomCheckbox.propTypes.indeterminate,
};

export default SFCheckbox;
